import React, { useEffect, useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Search } from "lucide-react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";

export default function SearchDialog({ open, onOpenChange }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (!q) { setResults([]); return; }
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get("/products", { params: { search: q, limit: 6 } });
        setResults(data);
      } catch { setResults([]); }
    }, 200);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl p-0 gap-0 overflow-hidden" data-testid="search-dialog">
        <div className="flex items-center gap-3 px-5 py-4 border-b">
          <Search className="w-4 h-4 text-muted-foreground" />
          <input
            data-testid="search-input"
            autoFocus
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search products..."
            className="bg-transparent flex-1 outline-none text-sm"
          />
          <kbd className="hidden md:inline text-[10px] font-mono px-1.5 py-0.5 rounded border border-border text-muted-foreground">ESC</kbd>
        </div>
        <div className="max-h-96 overflow-y-auto">
          {results.length === 0 ? (
            <div className="p-8 text-center text-sm text-muted-foreground">
              {q ? "No results" : "Start typing to search"}
            </div>
          ) : (
            <div className="p-2">
              {results.map((p) => (
                <Link
                  key={p.id}
                  to={`/product/${p.slug}`}
                  onClick={() => onOpenChange(false)}
                  className="flex items-center gap-3 p-2 rounded-lg hover:bg-secondary transition-colors"
                  data-testid={`search-result-${p.slug}`}
                >
                  <div className="w-12 h-12 rounded-md bg-secondary overflow-hidden flex-shrink-0">
                    {p.images?.[0] && <img src={p.images[0]} alt={p.name} className="w-full h-full object-cover" />}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium truncate">{p.name}</div>
                    <div className="text-xs text-muted-foreground">₹{p.price}</div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
